import React from 'react';
import ReactDOM from 'react-dom';
import Shell from './projects/Shell';

import boot from './projects/Shell/boot';
import request from './utils/axiosWrapper';

import './projects/Shell/index.module.scss';

// 初始化反扒模块
import('./utils/antiSpider');

const rootEl = document.getElementById('root');
/** loading图 */
rootEl!.innerHTML = `
    <div style="margin:auto; height:100%; display:flex; flex-direction: column; justify-content:center; align-items:center; font-size: 20px;">
        <img style="margin-bottom: 10px" src="${require('./projects/Shell/assets/loading.gif')}" />
        <div id="loading-txt">加载中...</div>
        <div id="loading-fail-txt" style="display: none">加载失败，<span onclick="window.location.reload()" style="color: #f89800; cursor: pointer; text-decoration: underline">点此</span>刷新页面重试</div>
        <div id="loading-demotion-info" style="display: none; margin: 20px; background-color: rgba(255, 25, 45, 0.1); border: 1px solid rgba(255, 25, 45, 0.3); padding: 9px 16px"></div>
    </div>
`;

boot().then(
    () => {
        // 🚀 Ready to go!
        ReactDOM.render(<Shell />, document.getElementById('root'));
    },
    () => {
        // 🚨 Houston, we've had a problem here.
        document.getElementById('loading-txt')!.style.display = 'none';
        document.getElementById('loading-fail-txt')!.style.display = 'block';

        // Boot 失败，请求挂牌接口查询是否存在已知故障
        request
            .rawGet<{
                code: number;
                data: {
                    demotionInfo: {
                        [index: string]: {
                            /** true为命中降级 */
                            hitStrategy: boolean;
                            /** 降级展示文案 */
                            context: string;
                            /** 服务端下发的轮询间隔 */
                            intervalSecond: number;
                        };
                    };
                };
            }>('/gw/api/config/demotion/interval/info', {
                params: {
                    demotionKey: 'order_demotion_key',
                    demotionType: 1,
                },
            })
            .then(
                response => {
                    if (response.code === 0 && response.data && response.data.demotionInfo) {
                        if (response.data.demotionInfo.order_demotion_key) {
                            const demotionInfo = response.data.demotionInfo.order_demotion_key;
                            if (demotionInfo.hitStrategy) {
                                // 确有挂牌信息
                                const $demotionInfo = document.getElementById(
                                    'loading-demotion-info',
                                );
                                if ($demotionInfo) {
                                    $demotionInfo.style.display = 'block';
                                    $demotionInfo.innerText = demotionInfo.context;
                                }
                            }
                        }
                    }
                },
                () => null,
            );
    },
);
